import React from 'react';
import { Box, Link, Text, Tooltip } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Enlace de navegación compartido entre AdminSidebar (escritorio) y
 * AdminMobileDrawer (Drawer móvil): idénticos estilos y soporte para
 * colapso compacto a solo icono con Tooltip.
 */
export default function AdminNavLink({ item, isActive, isCollapsed, onClick }) {
  const Icon = item.icon;

  const linkElement = (
    <Link
      as={RouterLink}
      to={item.href}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
      aria-label={isCollapsed ? item.label : undefined}
      display="flex"
      alignItems="center"
      justifyContent={isCollapsed ? 'center' : 'flex-start'}
      gap="10px"
      minH="40px"
      px={isCollapsed ? 0 : '12px'}
      mx={isCollapsed ? '6px' : '10px'}
      borderRadius="7px"
      borderLeft={isCollapsed ? 'none' : '3px solid'}
      borderLeftColor={isActive ? 'adminPanel.yellow' : 'transparent'}
      bg={isActive ? 'adminPanel.navyHover' : 'transparent'}
      color="white"
      fontWeight={isActive ? 700 : 500}
      fontSize="14px"
      _hover={{ bg: 'adminPanel.navyHover', textDecoration: 'none' }}
    >
      <Box
        as={Icon}
        aria-hidden="true"
        boxSize="18px"
        flexShrink={0}
        color={isActive ? 'adminPanel.yellow' : 'white'}
      />
      {!isCollapsed && (
        <Text
          fontSize="14px"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {item.label}
        </Text>
      )}
    </Link>
  );

  if (isCollapsed) {
    return (
      <Tooltip label={item.label} placement="right" hasArrow>
        {linkElement}
      </Tooltip>
    );
  }

  return linkElement;
}
